import { GetStaticPaths } from "next";
import { revalidate } from "../../../common/constants";
import Header from "../../../view/components/Header/Header";
import { NextSeo } from "next-seo";
import Posao from "../../../view/screens/Posao/Posao";
import { getAllJobsForBuild, getSimilarJobsByTags } from "../../api/job/get";
import { handleGetJob } from "../../api/job/get/job";
import { JobListing, JobSingle } from "../../../common/types";

type Posao = {
    job: JobSingle;
    similarJobs: JobListing[];
};

export default function PosaoPage({ job, similarJobs }: Posao) {
    return (
        <div className="relative bg-white">
            <Header />
            <NextSeo
                title={`${job.title} | ${job.meta.company}`}
                description={`${job.meta.company}, ${job.meta.level}, ${job.meta.cities}, ${job.meta.sallary}`}
                canonical={`https://www.dzobs.com/posao/${job.meta.companySlug}/${job.slug}`}
                openGraph={{
                    images: [
                        {
                            url: job?.meta?.companyLogo,
                        },
                    ],
                }}
            />
            <Posao data={job} similarJobs={similarJobs} />
        </div>
    );
}

export const getStaticPaths: GetStaticPaths = async () => {
    const jobs = await getAllJobsForBuild();

    const paths = jobs?.map((job) => ({
        params: { slug: job.slug, company: job.companies.slug },
    }));

    return {
        paths,
        fallback: "blocking",
    };
};

export async function getStaticProps({
    params,
}: {
    params: {
        company: string;
        slug: string;
    };
}) {
    const { company, slug } = params;

    const job = await handleGetJob(slug);

    const similarJobs = await getSimilarJobsByTags(job.tagsList);

    if (job) {
        return {
            props: {
                job,
                similarJobs: similarJobs?.data?.filter(
                    (current) => current.slug !== job.slug
                ),
            },
            revalidate: revalidate,
        };
    }

    if (!job) {
        return {
            notFound: true,
            revalidate: revalidate,
        };
    }
}
